// import AOS from 'aos';
export default {
  init() {
   // window.sr = ScrollReveal();
    // console.log(sr);
    // sr.reveal('.fade-in');
    // AOS.init();
  },
  finalize() {
    $("[name='url']").val(window.location.pathname.replace(/.*\/(\S+)\//img,"$1"));
    // window.sr = ScrollReveal();
    // console.log(sr);
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js